export default "__VITE_ASSET__5b33b885__"